export const minuteAddonId = (price) => ({ 0: 'none', 1.5: 'minutes-30', 3: 'minutes-60', 5: 'minutes-120' }[Number(price)]);
export const smsAddonId = (price) => ({ 0: 'none', 1.5: 'sms-50', 3: 'sms-100', 5: 'sms-200' }[Number(price)]);
export const usageAddonId = (price) => ({ 0: 'none', 3: 'usage-60-100', 5: 'usage-120-200' }[Number(price)]);

export function checkoutRequest(checkoutInfo, gateway) {
  return {
    amount: Math.round(parseFloat(checkoutInfo.total) * 100),
    productName: checkoutInfo.name,
    gateway,
    selection: checkoutInfo.selection || {},
  };
}
